export const BANNER_TYPE_OPTIONS = [
  { title: "HOME WEB", value: "HOME" },
  { title: "HOME APP", value: "HOME_MOBILE" },
  { title: "OFERTAS (carrusel home)", value: "OFFERS" },
  { title: "FONDO PÁGINA OFERTAS", value: "OFFERS_PAGE" },
  { title: "FONDO PÁGINA LIQUIDACIÓN", value: "LIQUIDATION_PAGE" },
  { title: "POPUP", value: "POPUP" },
  { title: "ACADEMIA", value: "ACADEMY" },
  { title: "OFERTAS RELÁMPAGO", value: "FLASH_SALE" },
] as const;

export type BannerSizeGuide = {
  desktop: string;
  mobile: string;
  note: string;
};

/** Medidas de subida (2× retina) según cómo se pintan en web/app. */
export const BANNER_SIZE_BY_TYPE: Record<string, BannerSizeGuide> = {
  HOME: {
    desktop: "2560 × 890 px",
    mobile: "1535 × 770 px",
    note: "Hero del home. Relación 2560×890 en desktop y 1535×770 en mobile. JPG o WebP, máximo 2 MB.",
  },
  HOME_MOBILE: {
    desktop: "1200 × 600 px",
    mobile: "1200 × 600 px",
    note: "La app usa la imagen mobile. Relación 2:1.",
  },
  OFFERS: {
    desktop: "2400 × 800 px",
    mobile: "1536 × 768 px",
    note: "Carrusel de ofertas. Relación 3:1 en desktop y 2:1 en mobile.",
  },
  FLASH_SALE: {
    desktop: "2400 × 800 px",
    mobile: "1536 × 768 px",
    note: "Misma proporción que el carrusel de ofertas.",
  },
  OFFERS_PAGE: {
    desktop: "2560 × 1200 px",
    mobile: "1536 × 768 px",
    note: "Fondo del hero de /ofertas. Foto sin texto: el copy va en la página.",
  },
  LIQUIDATION_PAGE: {
    desktop: "2560 × 1200 px",
    mobile: "1536 × 768 px",
    note: "Fondo del hero de /liquidacion. Foto sin texto: el copy va en la página.",
  },
  POPUP: {
    desktop: "1600 × 1600 px",
    mobile: "1280 × 1280 px",
    note: "Pieza cuadrada. El popup del home muestra la imagen completa, sin recortar.",
  },
  ACADEMY: {
    desktop: "1600 × 800 px",
    mobile: "1200 × 600 px",
    note: "Carrusel de academia. Relación 2:1.",
  },
};

export function getBannerSizeGuide(type?: string): BannerSizeGuide | null {
  if (!type) return null;
  return BANNER_SIZE_BY_TYPE[type] ?? null;
}

export const BANNER_TYPE_VALUES = BANNER_TYPE_OPTIONS.map(
  (option) => option.value
);

export const BANNER_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  BANNER_TYPE_OPTIONS.map((option) => [option.value, option.title])
);

export const isPageHeroType = (type?: string) =>
  type === "OFFERS_PAGE" || type === "LIQUIDATION_PAGE";
